export type FormOption = {
  label: string;
  value: string;
  disabled?: boolean;
  id?: string;
};
export type FormOptions = FormOption[];
export type FormOptionGroup = {
  label: string;
  description?: string;
  disabled?: boolean;
  options: FormOptions;
};
export type FormOptionGroups = FormOptionGroup[];

export type SortingOption = {
  columnId: string;
  options: FormOptions;
};

export type InitialDefaultValues = string | number | null | boolean | undefined;

export type GeneralFormProps = {
  onChange?: (...event: unknown[]) => void;
  name: string;
  id?: string;
  title?: string;
  value?: InitialDefaultValues;
  defaultValue?: InitialDefaultValues;
  description?: string;
  placeholder?: string;
  min?: number;
  max?: number;
  required?: boolean;
  disabled?: boolean;
};

export type TextInputProps = {
  variant:
    | 'text'
    | 'checkbox'
    | 'date'
    | 'switch'
    | 'number'
    | 'url'
    | 'email'
    | 'textarea';
} & GeneralFormProps;

export type WithOptionsProps = {
  variant: 'radio' | 'select' | 'combobox' | 'trigger_schedule';
  options: FormOptions;
} & GeneralFormProps;

export type NavItem = {
  href?: string;
  icon?: React.ReactNode;
  children?: NavItem[] | [];
  onClick?: () => void;
} & FormOption;

export type SuccessResponse = {
  message: string;
};

export type TranslateFunction = (
  key: string,
  values?: Record<string, unknown>,
) => string;

export type LanguageOption = {
  code: string;
  name: string;
};

export type LanguageOptions = LanguageOption[];

// Language-specific URL type for external links (courses, sequences, etc.)
export type LanguageUrl = {
  languageCode: string;
  url: string | null;
};

export type ComponentSize = number | 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export enum SizeMap {
  xs = 16,
  sm = 24,
  md = 32,
  lg = 40,
  xl = 48,
}

export function getComponentSize(size: ComponentSize): number {
  return typeof size === 'number' ? size : SizeMap[size];
}

export type IconProps = {
  icon: string;
  className?: string;
  size?: ComponentSize;
};
